exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stores-panel {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 16px;\n  margin: 0 16px 16px;\n  font-size: 16px;\n  height: 9vh;\n  border: 1px solid #dbdbdb;\n  background-color: #ffffff;\n}\n.stores-panel__info {\n  display: flex;\n  align-items: center;\n}\n.stores-panel__create-store__button {\n  border-radius: 0 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Stores/components/StoresPanel/StoresPanel.less
// module id = 901
// module chunks = 0